// US_06 — endpoint paths (web-service codes) gom 1 chỗ, không inline trong service.
const base = "/reports/personal";

/** §1 — xác thực report-GT (đổi SSO access token → JWT report-GT & vai trò). */
export const REPORT_AUTH_WS = {
  /** §1 — `POST /api/auth/generate-token`. */
  generateToken: "/auth/generate-token",
  /** §1.1 — `GET /api/reports/me` (vai trò tính LIVE). */
  me: "/reports/me",
};

export const REPORT_WS = {
  /** §2.1 — hồ sơ + KPI (bỏ id → của chính người gọi). */
  personal: (userId?: number | string) => (userId ? `${base}/${userId}` : base),
  /** §2.2 — xu hướng năm. */
  trend: (userId: number | string) => `${base}/${userId}/trend`,
  /** §2.3 — điểm hành vi. */
  behaviors: (userId: number | string) => `${base}/${userId}/behaviors`,
  /** §2.4 — phản hồi đồng nghiệp. */
  feedback: (userId: number | string) => `${base}/${userId}/feedback`,
  /** §2.5 — quick-search nhân viên. */
  search: `${base}/search`,
  /** §2.6 — tuỳ chọn bộ lọc: tháng mặc định + tháng đã chốt (enabled). */
  filters: `${base}/filters`,
};
